<!--
 * @Author: MouXiaowei
 * @Date: 2022-11-01 16:24:02
 * @Description: 加油金抽奖
-->
<template>
    <div class="home-box">
      <div class="top-box">
        <div class="top-account">
          <img class="top-account-icon" src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/lottery/refueling/refuelingMoney_money.png"/>
          <div class="top-account-value">{{'您的加油金：' + oilAmount}}</div>
        </div>
        <img class="top-record" src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/lottery/refueling/refuelingMoney_record.png" @click="handleRecordClick"/>
      </div>
      <div class="big-wheel-box">
          <big-wheel
          width="317px"
          height="317px"
          ref="bigWheel"
          :prizeList="prizeList"
          @over="over">
              <template v-slot:item="{ item }">
                  <img class="prize-img" :src="item.img">
              </template>
          </big-wheel>

          <!-- 开始按钮 -->
          <img v-if="collectToday" class="btn-go" src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/lottery/refueling/lottery_go_disenable.png" />
          <img v-else class="btn-go" @click="go" src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/lottery/refueling/lottery_go_enable.png" />
      </div>
      <div class="lottery-bottom">
          <img class="lottery-bottom-img" src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/lottery/lottery_bottom.png"/>
      </div>

      <div class="prize-box">
        <div class="coupon-box">
          <div v-for="(item, index) in couponList" :key="index">
            <div class="coupon-item">
              <div class="coupon-item-left">
                <div class="coupon-item-left-unit">¥</div>
                <div class="coupon-item-left-value">{{item.batchMoney}}</div>
              </div>
              <div class="coupon-item-right">
                <div class="coupon-item-right-desc">
                  <div class="coupon-item-right-desc-title">{{item.showTitle}}</div>
                  <div class="coupon-item-right-desc-rule">( 需消耗<span class="coupon-item-right-desc-rule-red">{{item.limitCount + '加油金'}}</span> )</div>
                </div>
                <div v-if="item.state == 3" class="coupon-item-right-btn-disable">已兑光</div>
                <div v-else class="coupon-item-right-btn" @click="handleExchange(item)">兑换</div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="adInfo != null" class="banner-box">
          <img class="banner-img" :src="adInfo.appIconUrl" @click="handleAppJumpWith(adInfo)"/>
        </div>
        <div class="rule-box">
          <div class="rule-title">
            <div class="prize-point"></div>
            <div class="prize-title">活动规则</div>
            <div class="prize-point"></div>
          </div>
          <div class="rule-desc" v-html="rules"></div>
        </div>
      </div>

      <van-popup class="lottery-dialog-box" v-model="isShowRewardDialog" :safe-area-inset-bottom="true" :close-on-click-overlay="false">
          <div class="lottery-dialog">
              <div class="lottery-dialog-img">
                  <div class="lottery-dialog-img-prize">{{isLotteryDialog ? '加油金奖励' : '加油金兑换'}}</div>
              </div>
              <div v-if="isLotteryDialog" class="lottery-dialog-content">
                  <div class="lottery-dialog-title">恭喜您获得</div>
                  <p class="lottery-dialog-value">{{'加油金 ' + luckAmount}}</p>
              </div>
              <div v-else class="lottery-dialog-content">
                <div class="lottery-dialog-title">{{'确认使用 ' + exchangeNum + ' 加油金兑换券吗？'}}</div>
                <div class="lottery-dialog-btn">
                  <div class="lottery-dialog-btn-cancel" @click="handlePopupClose">取消</div>
                  <div class="lottery-dialog-btn-confirm" @click="handleExchangeConfirm">确认</div>
                </div>
              </div>
              <img class="lottery-dialog-close" src="~@/assets/images/super/sign_dialog_close.png"  @click="handlePopupClose"/>
          </div>
      </van-popup>
    </div>
  </template>
<script>
import { setStore } from '@/utils/index'
import { queryOilLuckDrawInfo, oilLuckDraw, oilLuckDrawExchange } from '@/api/active'
import { queryAd } from '@/api/cmbCreditCard'
import BigWheel from '@/components/lottery/BigWheel'
import { Toast, Popup } from 'vant'
export default {
  name: 'refuelingMoney',
  components: {
    [Popup.name]: Popup,
    BigWheel
  },
  data () {
    return {
      prizeList: [
        {
          img: 'https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/lottery/refueling/lottery_prize_1.png'
        },
        {
          img: 'https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/lottery/refueling/lottery_prize_2.png'
        },
        {
          img: 'https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/lottery/refueling/lottery_prize_3.png'
        },
        {
          img: 'https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/lottery/refueling/lottery_prize_4.png'
        },
        {
          img: 'https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/lottery/refueling/lottery_prize_5.png'
        },
        {
          img: 'https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/lottery/refueling/lottery_prize_6.png'
        }
      ],
      prizeBgColors: ['#FFF7C8', '#FFF7C8'],
      borderColor: '#F9614B',
      turnsNumber: 3,
      turnsTime: 3,
      valve: false, // 防止连续点击

      isShowRewardDialog: false, // 中奖弹框
      isLotteryDialog: false, // 是否是抽奖弹框
      exchangeNum: 0, // 兑换弹框兑换加油金数量
      currentExchangeCouponInfo: null, // 当前兑换的优惠券信息

      adInfo: null, // 广告位
      oilAmount: null, // 可用加油金
      checkValue: null, // 优惠券兑换校验值
      collectToday: false, // 当日是否已抽奖 true 当日已抽 false 当日未抽
      rules: null, // 活动规则
      oilActivityExchangeRules: null, // 加油金优惠券兑换使用规则
      couponList: [],
      luckAmount: 0 // 最新一次抽奖中奖金额
    }
  },
  mounted () {
    const token = this.$route.query.accessToken
    if (token) {
      setStore('token', token)
    }
    this.getOilLuckDrawInfo()
    this.getAdBanner()
  },
  methods: {
    // 关闭弹框
    handlePopupClose () {
      this.isShowRewardDialog = false
      this.isLotteryDialog = true
    },
    // 弹框按钮跳转
    handleAppJumpWith (appVO) {
      // eslint-disable-next-line no-undef
      dsBridge.call('callNativeViewLifeCycle', {
        ...appVO,
        refreshFlag: 1
      })
    },
    // 领取记录
    handleRecordClick () {
      this.$router.push('/refuelingMoneyRecord')
    },
    // 兑换券
    handleExchange (item) {
      this.currentExchangeCouponInfo = item
      this.isShowRewardDialog = true
      this.isLotteryDialog = false
      this.exchangeNum = item.limitCount
    },
    // 兑换优惠券确认按钮点击
    handleExchangeConfirm () {
      this.isShowRewardDialog = false
      this.isLotteryDialog = true
      this.oilLuckDrawExchange()
    },
    // 获取中奖活动详情信息
    getOilLuckDrawInfo () {
      const query = {

      }
      queryOilLuckDrawInfo(query).then((res) => {
        if (res.data.code === 200) {
          if (res.data) {
            if (res.data.result) {
              this.resetData(res)
            }
          }
        }
      })
    },
    resetData (res) {
      this.oilAmount = res.data.result.oilAmount
      this.rules = res.data.result.rules
      this.collectToday = res.data.result.collectToday
      this.checkValue = res.data.result.checkValue
      this.oilActivityExchangeRules = res.data.result.oilActivityExchangeRules
      this.couponList = res.data.result.couponBatchDTOS
      if (this.couponList != null && this.couponList.length > 0) {
        this.couponList.forEach((item) => {
          if (this.oilActivityExchangeRules != null && this.oilActivityExchangeRules.length > 0) {
            let oilActivityExchangeRulesTemp = this.oilActivityExchangeRules.split(',')
            if (oilActivityExchangeRulesTemp != null && oilActivityExchangeRulesTemp.length > 0) {
              oilActivityExchangeRulesTemp.forEach((oilActivityExchangeRule) => {
                let oilActivityExchangeRuleArr = oilActivityExchangeRule.split('-')
                if (oilActivityExchangeRuleArr != null && oilActivityExchangeRuleArr.length === 3) {
                  if (item.batchId === oilActivityExchangeRuleArr[0]) {
                    this.$set(item, 'limitCount', oilActivityExchangeRuleArr[1])
                    this.$set(item, 'typeDesc', oilActivityExchangeRuleArr[2])
                  }
                }
              })
            }
          }
        })
      }
    },
    // 抽奖
    getLotteryRes () {
      const query = {

      }
      oilLuckDraw(query).then((res) => {
        if (res.data.code === 200) {
          if (res.data) {
            if (res.data.result) {
              this.luckAmount = res.data.result.luckAmount
              this.resetData(res)
              this.isShowRewardDialog = true
              this.isLotteryDialog = true
            }
          }
        }
      }).catch(() => {

      })
    },
    // 兑换优惠券请求
    oilLuckDrawExchange () {
      const query = {
        batchId: this.currentExchangeCouponInfo.batchId,
        amount: this.currentExchangeCouponInfo.limitCount,
        checkValue: this.checkValue,
        typeDesc: this.currentExchangeCouponInfo.typeDesc
      }
      oilLuckDrawExchange(query).then((res) => {
        this.lotteryCount -= 1
        if (res.data.code === 200) {
          if (res.data) {
            if (res.data.result) {
              Toast({
                message: '兑换成功'
              })
              this.resetData(res)
            }
          }
        }
      }).catch(() => {

      })
    },
    getAdBanner () {
      const query = {
        placeId: 266, // 广告位ID 固定值
        version: '-1', // 固定为-1
        platformType: 3 // 固定为3（代表H5）
      }
      queryAd(query).then(res => {
        const resData = res.data
        if (resData.code === 200) {
          let adList = resData.result
          if (adList.length > 0) {
            this.adInfo = adList[0]
          }
        }
      })
    },
    // 开始转动
    go () {
      if (this.valve) {
        return
      }
      if (this.collectToday) {
        Toast({
          message: '今日抽奖次数已用完！'
        })
        return
      }
      this.valve = true
      // 模拟随机数，这里可以请求后台获取中将信息
      const index = Math.floor(Math.random() * this.prizeList.length)
      this.winningIndex = index

      // 转动转盘
      this.$refs.bigWheel.rotate(index)
    },
    // 转盘转完事件
    over (prizeInfo) {
      this.valve = false
      this.getLotteryRes()
    }
  }
}
</script>
  <style lang="scss">
  .home-box {
    position: relative;
    overflow: hidden;
    width: 100%;
    min-height: 100vh;
    background: #bad7c0 url('https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/lottery/refueling/refuelingMoney_bg.png') no-repeat;
    background-repeat: no-repeat;
    background-position: center top;
    background-size: 100%;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    .top-box {
      margin-top: 12.5px;
      height: 35px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;

      .top-account {
        width: 193px;
        height: 27px;
        border-radius: 5px 5px 5px 5px;
        background: rgba(255,255,255,1);
        display: flex;
        flex-direction: row;
        align-items: center;
        .top-account-icon {
          margin-left: 10px;
          width: 22.5px;
          height: 19px;
        }
        .top-account-value {
          margin-left: 10.5px;
          font-weight: 700;
          font-size: 16px;
          color: #1D745D;
        }
      }
      .top-record {
        position: absolute;
        right: 0px;
        top: 12.5px;
        width: 81px;
        height: 35px;
      }
    }
    .big-wheel-box {
      margin-top: 9.5px;
      background-image: url('https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/lottery/lottery_wheel_bg.png');
      background-repeat: no-repeat;
      background-position: center;
      background-size: 100%;
      padding: .76rem;
      .prize-img {
        position: absolute;
        top: 40px;
        left: 50%;
        transform: translateX(-50%);
        width: 55px;
        height: 55px;
      }
      .btn-go {
        position: absolute;
        top: 158px;
        left: 50%;
        transform: translateX(-50%);
        width: 85px;
      }
    }
    .lottery-bottom {
      &-img {
          width: 256px;
      }
    }
    .prize-box {
      margin-top: 18.5px;
      padding-bottom: 20px;
      margin-bottom: 20px;
      width: (704vw / 7.5);
      border-radius: 9.5px 9.5px 9.5px 9.5px;
      border: 3px solid #69A159;
      background: rgba(255,255,255,1);
      display: flex;
      flex-direction: column;
      align-items: center;
      .banner-box {
        margin-top: 20px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        .banner-img {
          width: (626vw / 7.5);
        }
      }
      .rule-box {
        margin-top: 25px;
        display: flex;
        flex-direction: column;
        .rule-desc {
          margin-top: 15px;
          padding-left: 15px;
          padding-right: 15px;
          line-height: 28px;
          font-weight: 400;
          font-size: 14px;
          color: #3B4F26;
        }
        .rule-title {
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          height: 20px;
          .prize-point {
            width: 30px;
            height: 1px;
            background: #3B4F26;
          }
          .prize-title {
            font-weight: Bold;
            font-size: 15px;
            padding-left: 20px;
            padding-right: 20px;
            color: #3B4F26;
            line-height: 30px;
          }
        }
      }
      .coupon-box {
        margin-top: 5px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .coupon-item {
          background: url('https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/lottery/refueling/refuelingMoney_coupon_bg.png') no-repeat;
          background-position: center;
          background-size: 100%;
          width: (640vw / 7.5);
          height: 60px;
          overflow-x: hidden;
          margin-top: 11.5px;
          display: flex;
          flex-direction: row;

          .coupon-item-left {
            width: (180vw / 7.5);
            height: 60px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            &-unit {
                height: 24px;
                display: flex;
                flex-direction: column;
                justify-content: flex-end;
                color: #E5643F;
                font-size: 12px;
                font-weight: 900;
            }
            &-value {
                margin-left: 3px;
                color: #E5643F;
                font-size: 28px;
                font-weight: 900;
            }
          }

          .coupon-item-right {
            flex: 1;
            height: 60px;
            display: flex;
            flex-direction: row;
            align-items: center;
            .coupon-item-right-desc {
                flex: 1;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                .coupon-item-right-desc-title {
                    color: #E5643F;
                    font-size: 13px;
                    font-weight: 400;
                }
                .coupon-item-right-desc-rule {
                    margin-top: 6px;
                    color: #333233;
                    font-size: 13px;
                    font-weight: 500;
                }
                .coupon-item-right-desc-rule-red {
                    margin-top: 6px;
                    color: #E5643F;
                    font-size: 13px;
                    font-weight: 500;
                }
            }
            .coupon-item-right-btn {
                margin-right: 12px;
                width: 62px;
                height: 30px;
                border-radius: 15px;
                background: #E5643F;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                color: #fff;
                font-size: 13px;
                font-weight: 400;
            }
            .coupon-item-right-btn-disable {
                margin-right: 12px;
                width: 62px;
                height: 30px;
                border-radius: 15px;
                background: #313031;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                color: #fff;
                font-size: 13px;
                font-weight: 400;
            }
          }
        }
      }
    }
  }

  .lottery-dialog-box {
      background-color: rgba($color: #fff, $alpha: 0);
  }
  .lottery-dialog {
      display: flex;
      flex-direction: column;
      align-items: center;

      .lottery-dialog-img {
          background-image: url('https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/lottery/refueling/refuelingMoney_dialog_icon.png');
          background-repeat: no-repeat;
          background-position: center;
          background-size: 100%;
          width: 166px;
          height: 107px;
          z-index: 1;
          .lottery-dialog-img-prize {
              margin-top: 68px;
              line-height: 20px;
              font-weight: 400;
              font-size: 17px;
              text-align: center;
              color: #4F3606;
          }
      }

      .lottery-dialog-close {
          margin-top: 25px;
      }

      .lottery-dialog-content {
          margin-top: -30px;
          padding-bottom: 20px;
          width: 250px;
          background-color: #fff;
          border-radius: 8px;
          display: flex;
          flex-direction: column;
          align-items: center;
          .lottery-dialog-title {
              margin-top: 40px;
              height: 21px;
              font-weight: 500;
              font-size: 16px;
              color: #333233;
          }
          .lottery-dialog-value {
              margin-top: 10px;
              height: 18px;
              font-weight: 400;
              font-size: 16px;
              color: #333233;
          }
          .lottery-dialog-btn {
              margin-top: 22px;
              height: 40px;
              width: 250px;
              display: flex;
              background-color: #fff;
              flex-direction: row;
              justify-content: center;
              align-items: center;
              &-cancel {
                width: 100px;
                height: 36px;
                border-radius: 18px 18px 18px 18px;
                border: 0.5px solid rgba(249,97,75,1);
                background: #fff;
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                font-weight: 400;
                font-size: 14px;
                color: #F9614B;
              }
              &-confirm {
                margin-left: 20px;
                width: 100px;
                height: 36px;
                border-radius: 18px 18px 18px 18px;
                background: rgba(249,97,75,1);
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                font-weight: 400;
                font-size: 14px;
                color: #fff;
              }
          }
      }
  }

  </style>
